import { CoreEnums } from '@/utils/domain/constants';

const { DelegatedTaskStatus } = CoreEnums;

import _ from 'lodash';

export const Status = {
  [DelegatedTaskStatus.Delegated]: {
    id: 'delegatedTasks.delegated',
    color: 'success',
  },
  [DelegatedTaskStatus.Deleted]: {
    id: 'delegatedTasks.deleted',
    color: 'voided',
  },
};

export const DelegatedTaskStatusFilter = () => {
  return _.map(DelegatedTaskStatus, (l, key) => {
    return {
      value: `Automy.Core.Enums.DelegatedTaskStatus'${key}'`,
      label: `delegatedTasks.${key.toLowerCase()}`,
    };
  });
};
